import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Чаршафи от 100% памук | Голям избор от размери | GoToBed',
  description:
    'Памучни долни чаршафи от 100% памук в над 100 размера. Ранфорс и памучен сатен, размери от 110/210 до 360/360 см. Поръчайте онлайн от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи от 100% памук в голямо разнообразие от размери
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи от 100% памук в голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете долни чаршафи от 100% памук в изключително богато
          разнообразие от размери – нашето най-голямо предимство. Това улеснява избора на точния
          чаршаф за всяко легло и всеки матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Колекцията включва както едноцветни модели, така и шарени десени с принт, подходящи за
          различни стилове спално бельо. Сред популярните размери ще откриете 150/220, 160/240,
          180/220, 200/220, 220/240, 240/260, 260/280 и 300/320, както и още варианти за по-голямо
          удобство при избора.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете цялостен комплект спално бельо, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите чаршафи с ластик, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyCharshafi />;
}

function SeoBodyCharshafi() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Памучни долни чаршафи по размер */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи – памучни долни чаршафи по размер
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафът е една от основните части на спалното бельо и има пряко влияние върху комфорта по
        време на сън. Затова е важно да бъде изработен от качествена материя и да бъде в подходящия
        размер за матрака.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed предлагаме памучни долни чаршафи по размер, изработени от висококачествени платове
        – 100% памук ранфорс и памучен сатен. Всеки модел се изработва внимателно в България и е
        съобразен с избраните от клиента размери.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В нашия онлайн магазин можете лесно да изберете чаршаф по размер на матрака, който покрива
        добре леглото и позволява удобно подпъхване.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете едноцветни и шарени чаршафи, подходящи за различни видове легла
        – от единични до големи двойни легла.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако предпочитате конкретна материя, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi/1/1/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi/1/1/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Стандартни и нестандартни размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи за стандартни и нестандартни размери матраци
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от най-големите предимства на нашите продукти е богатото разнообразие от размери.
          Предлагаме над 100 различни варианта, подходящи както за стандартни, така и за
          нестандартни матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Размерите могат да бъдат изработени в диапазон от 110/210 см до 360/360 см, като се
          увеличават през 10 см. Това позволява лесно да намерите подходящ вариант дори за по-големи
          или специфични легла.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред популярните размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['160/240', '180/220', '200/220', '220/240', '240/260', '260/280', '300/320'].map(
            (size) => (
              <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
                {size}
              </Typography>
            )
          )}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Благодарение на този богат избор можете лесно да откриете подходящ чаршаф по размер, който
          пасва добре на вашия матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако не намирате точния размер в стандартните магазини, изработката по размер е практично и
          удобно решение.
        </Typography>

        {/* Чаршафи за големи легла */}
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          При по-големи двойни легла е важно чаршафът да бъде достатъчно широк, за да покрива добре
          матрака и да може удобно да се подпъхва под него. В нашия магазин ще откриете голям избор
          от модели за големи легла, включително размери като 220/240, 240/260, 260/280 и 300/320
          см.
        </Typography>

        {/* H2: Памучни чаршафи – комфорт и дишаемост */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Памучни чаршафи – комфорт и дишаемост
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памукът е предпочитан материал за спално бельо, защото осигурява естествена дишаемост и
          комфорт по време на сън. Всеки памучен чаршаф е приятен на допир и подходящ за ежедневно
          използване.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме два основни вида плат:
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, подходящ за ежедневна употреба.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е по-фина и гладка памучна материя с лек естествен блясък и по-меко
          усещане.
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Платовете са сертифицирани по OEKO-TEX Standard 100, което гарантира безопасност и високо
          качество на текстила.
        </Typography>

        {/* H2: Предимства на нашите чаршафи */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите чаршафи
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук – ранфорс или памучен сатен</li>
          <li>&#10004; над 100 различни размера</li>
          <li>&#10004; размери от 110/210 до 360/360 см</li>
          <li>&#10004; увеличаване през 10 см за по-точно прилягане</li>
          <li>&#10004; шарени и едноцветни модели</li>
          <li>&#10004; подходящи за стандартни и нестандартни матраци</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всеки чаршаф се изработва внимателно, за да осигури комфорт, издръжливост и добро
          прилягане към матрака.
        </Typography>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите се изработват индивидуално след направена поръчка според избрания размер и
          материя.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          След изработката поръчката се изпраща с куриер до посочения от вас адрес или до офис на
          куриерската фирма.
        </Typography>

        {/* H2: Популярни размери чаршафи */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери чаршафи
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Най-често клиентите търсят размери като 220/240, 240/260 или 260/280, които позволяват
          удобно покриване и подпъхване под матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените варианти са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['160/240', '180/220', '200/220', '220/240', '240/260', '260/280', '300/320'].map(
            (size) => (
              <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
                {size}
              </Typography>
            )
          )}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на богатия избор можете лесно да намерите подходящ чаршаф както за
          стандартни, така и за по-големи матраци.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за чаршафи
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящия долен чаршаф, измерете ширината, дължината и височината на
            матрака. След това изберете чаршаф с подходяща ширина и дължина. Ако желаете чаршафът да
            се подпъхва под матрака, е добре да изберете малко по-голям размер, за да има достатъчно
            плат за подпъхване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се памучният чаршаф след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Както всички изделия от 100% памук, и памучните чаршафи могат да имат естествена
            свиваемост около 4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв размер чаршаф е подходящ за матрак 160/200, 180/200 или 200/200?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            При чаршафите без ластик обикновено се избира по-голям размер от размера на матрака, за
            да има достатъчно плат за покриване и подпъхване. Например:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>за матрак 160/200 см – чаршаф 220/240 или 240/260</li>
            <li>за матрак 180/200 см – чаршаф 240/270 или по-голям</li>
            <li>за матрак 200/200 см – чаршаф 260/280 или по-голям</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите за големи матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме чаршафи в над 100 различни размера, включително и за много големи матраци
            до 360/360 см.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера – ранфорс или памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двата плата са изработени от 100% памук и осигуряват отличен комфорт по време на сън.
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>Ранфорс – по-плътен и издръжлив плат.</li>
            <li>Памучен сатен – по-фин, по-мек и гладък плат с лек блясък.</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избраните
            размери.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
